'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _functional = require('../utils/functional');

var _fadeIn = require('../components/fade-in');

var _fadeIn2 = _interopRequireDefault(_fadeIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numberRegex = /[0-9]+/;

var LoadMore = function () {
  function LoadMore(el) {
    var _this = this;

    (0, _classCallCheck3.default)(this, LoadMore);

    var context = { context: el };
    this.els = {
      el: el,
      text: (0, _functional.getElement)('[data-module-load-more-text]', context),
      button: (0, _functional.getElement)('[data-module-load-more-button]', context),
      target: (0, _functional.getElement)('[data-module-load-more-target]')
    };

    this._loading = false;
    this.listItemClass = '.' + this.els.target.children[0].className;
    this.currentPage = parseInt(this.els.el.dataset.page, 10);
    this.perPage = parseInt(this.els.el.dataset.perPage, 10);
    this.totalItems = parseInt(this.els.el.dataset.totalItems, 10);

    this.els.el.addEventListener('click', (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var _ref2, data, fragment, div;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              _this.currentPage += 1;
              _context.next = 4;
              return _axios2.default.get(_this.els.el.dataset.url + '?page=' + _this.currentPage);

            case 4:
              _ref2 = _context.sent;
              data = _ref2.data;

              _this.loading = false;
              fragment = document.createDocumentFragment();
              div = (0, _functional.createElement)('div');

              div.innerHTML = data;
              (0, _functional.getElements)(_this.listItemClass, { context: div }).forEach(function (item) {
                fragment.appendChild(item);
              });

              _this.els.target.appendChild(fragment);

              _this.setCurrentAmountViewed();

              new _fadeIn2.default((0, _functional.getElements)('.js-FadeIn:not(.js-FadeIn-visible)'));

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    })));
  }

  (0, _createClass3.default)(LoadMore, [{
    key: 'setCurrentAmountViewed',
    value: function setCurrentAmountViewed() {
      var currentTotal = (0, _functional.getElements)(this.listItemClass + ':not(' + this.listItemClass + '-advert)').length;

      this.els.text.innerText = this.els.text.innerText.replace(numberRegex, currentTotal);

      if (currentTotal === this.totalItems) {
        this.els.button.remove();
      }
    }
  }, {
    key: 'loading',
    get: function get() {
      return this._loading;
    },
    set: function set(val) {
      this._loading = val;

      this.els.button.setAttribute('aria-busy', String(val));
    }
  }]);
  return LoadMore;
}();

exports.default = LoadMore;